"use client";

import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import MainContent from './components/layout/MainContent';
import Sidebar from './components/layout/Sidebar';
import SearchPrompt from './components/ui/SearchPrompt';
import MobileNavigation from './components/layout/MobileNavigation';
import MobileHeader from './components/layout/MobileHeader';

export default function Home() {
  // State to control mobile drawer
  const [mobileOpen, setMobileOpen] = useState(false);
  const router = useRouter();
  
  // Update document title and meta tags manually
  useEffect(() => {
    // Set document title
    document.title = "OpenMenu.pk | Discover the Best Restaurants & Menus in Your City";
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Order food online from the best restaurants in Pakistan. Browse menus, see reviews, and enjoy fast delivery with OpenMenu.pk - your AI-powered food ordering assistant.";
    
    // Add structured data
    let scriptLD = document.querySelector('script[type="application/ld+json"]');
    if (!scriptLD) {
      scriptLD = document.createElement('script');
      scriptLD.type = "application/ld+json";
      document.head.appendChild(scriptLD);
    }
    
    scriptLD.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": "https://openmenupk.com/",
      "name": "OpenMenu.pk",
      "description": "Order food online from the best restaurants in Pakistan.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://openmenupk.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    });
  }, []);
  
  return (
    <main className="flex min-h-screen bg-gray-50">
      {/* Sidebar - Hidden on mobile, toggleable via drawer */}
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      
      {/* Mobile Header - Visible only on mobile */}
      <MobileHeader setMobileOpen={setMobileOpen} />
      
      {/* Main Content Area */}
      <MainContent />
      
      {/* Mobile Bottom Navigation - Visible only on mobile */}
      <MobileNavigation />
      
      {/* Global Search Bar */}
      <SearchPrompt />
    </main>
  );
} 